export default "/images/a1abe2167739503894781ae24f72a5df.avif";